/* v45 BLOK 1 — Authoritative re-render via Shopify Section Rendering API.
   Replaces v39-v44 in-place DOM mutation (which desync'd on remove: header H1,
   item rows, callout, discount row drifted from Shopify's true state).
   Single source of truth = Liquid render. Fetch /cart?section_id=lc-cart-main
   after every cart mutation; swap section innerHTML. Event handlers are
   delegated to the stable outer .lc-cart section element so they survive the
   innerHTML replacement.
   Graceful no-JS fallback unchanged: form action="/cart" + name="updates[]"
   submits natively; Remove link `href` is the real Shopify remove URL. */
(function () {
  'use strict';

  var section = document.querySelector('[data-lc-cart]');
  if (!section) return;

  function setLoading(row, on) {
    if (!row) return;
    row.classList.toggle('is-removing', on);
  }
  function setSectionLoading(on) {
    section.classList.toggle('is-cart-loading', on);
  }

  // POST quantity change to Shopify cart endpoint.
  // Per Shopify docs `id` accepts the line key (e.g. "43355769995367:abc..."),
  // the variant id, or 1-indexed line number. Liquid emits item.key into
  // `data-line-key` — canonical and stable across line reorders.
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart change failed: ' + r.status);
      return r.json();
    });
  }

  // Authoritative re-render: fetch the section as Shopify currently renders it
  // (post-mutation cart state) and replace the entire section's innerHTML.
  // Server-rendered values — item list, header count, callout state text,
  // discount row, Estimated total — are all in sync because they come from the
  // SAME Liquid render in ONE request.
  function reloadCart() {
    setSectionLoading(true);
    return fetch('/cart?section_id=lc-cart-main', {
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        // Section Rendering API returns just the section template wrapped in a
        // shopify-section element. Find the cart section root inside.
        var fresh = tmp.querySelector('[data-lc-cart]');
        if (!fresh) {
          // Defensive: if structure changed (e.g. cart cleared via another tab),
          // do a hard reload so the server-rendered empty state appears.
          window.location.reload();
          return;
        }
        section.innerHTML = fresh.innerHTML;
        // Restore animation timing (CSS @keyframes auto-runs on new nodes).
      })
      .catch(function (e) {
        console.warn('[v45] section reload failed:', e);
        // Hard reload as last resort so the UI never sticks in a stale state.
        window.location.reload();
      })
      .finally(function () { setSectionLoading(false); });
  }

  // ── Delegated click handler (stepper + remove). Section is stable; its
  // innerHTML is the part that changes — listeners on `section` itself are
  // preserved across reloadCart() swaps.
  section.addEventListener('click', function (e) {
    // Quantity stepper
    var stepBtn = e.target.closest('[data-lc-cart-qty-dir]');
    if (stepBtn) {
      var rowS = stepBtn.closest('[data-lc-cart-item]');
      if (!rowS) return;
      var input = rowS.querySelector('[data-lc-cart-qty-input]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 0;
      var dir = stepBtn.getAttribute('data-lc-cart-qty-dir');
      var next = dir === 'inc' ? current + 1 : current - 1;
      if (next < 0) next = 0;
      input.value = String(next);
      setLoading(rowS, true);
      changeLine(rowS.getAttribute('data-line-key'), next)
        .then(reloadCart)
        .catch(function () { setLoading(rowS, false); });
      return;
    }
    // Remove link
    var rm = e.target.closest('[data-lc-cart-remove]');
    if (rm) {
      e.preventDefault();
      var rowR = rm.closest('[data-lc-cart-item]');
      if (!rowR) return;
      setLoading(rowR, true);
      changeLine(rowR.getAttribute('data-line-key'), 0)
        .then(reloadCart)
        .catch(function () { setLoading(rowR, false); });
    }
  });

  // Direct numeric input (blur)
  section.addEventListener('change', function (e) {
    var input = e.target.closest('[data-lc-cart-qty-input]');
    if (!input) return;
    var row = input.closest('[data-lc-cart-item]');
    if (!row) return;
    var qty = parseInt(input.value, 10);
    if (!isFinite(qty) || qty < 0) qty = 0;
    setLoading(row, true);
    changeLine(row.getAttribute('data-line-key'), qty)
      .then(reloadCart)
      .catch(function () { setLoading(row, false); });
  });

})();
